function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { retrieveBulkServicesTemplate } from '../../../../../reducers/actions/order.details.actions';
import { OrderDetailsExportingBulkServiceAttributesErrorSelector, OrderDetailsIsExportingBulkServiceAttributesSelector } from '../../../../../reducers/selectors/order.details.selectors';
var ExportBulkAttributesModalController = /*#__PURE__*/function () {
  function ExportBulkAttributesModalController($ngRedux) {
    _classCallCheck(this, ExportBulkAttributesModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      i18n: i18n
    });
  }
  return _createClass(ExportBulkAttributesModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        retrieveBulkServicesTemplate: retrieveBulkServicesTemplate
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isExportingBulkServiceAttributes: OrderDetailsIsExportingBulkServiceAttributesSelector(store),
          isExportingBulkServiceAttributesError: OrderDetailsExportingBulkServiceAttributesErrorSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.actions.retrieveBulkServicesTemplate(this.orderDetails).then(function (response) {
        _this.serviceTemplateFilename = response.Filename;
        _this.templateUrl = response.Url;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "close",
    value: function close() {
      this.onClose()();
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&',
    orderDetails: '<'
  },
  controller: ExportBulkAttributesModalController,
  controllerAs: 'ExportBulkAttributesModal',
  template: require('./export.bulk.attributes.modal.html')
};